/* Cart drawer extras: free shipping bar, upsell row, discount codes, /cart page sync.
   Dawn's cart-drawer.js and cart.js still own opening, closing, focus and line edits. */
(function () {
  'use strict';

  var recommendationCache = {};
  var discountOpen = false;
  var discountError = '';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function isOpen() {
    var el = drawer();
    return !!el && el.classList.contains('active');
  }

  /* Build a formatter from a sample Shopify rendered with its own money filter,
     so symbol, separators and position always match the shop's format. */
  function moneyFormatter(sample) {
    var match = (sample || '').match(/\d[\d.,'\s]*\d/);
    if (!match) {
      return function (cents) {
        return (cents / 100).toFixed(2);
      };
    }
    var number = match[0];
    var decimals = /[.,]\d{2}$/.test(number) ? number.charAt(number.length - 3) : '';
    var whole = decimals ? number.slice(0, -3) : number;
    var group = (whole.match(/[^\d]/) || [''])[0];
    return function (cents) {
      var value = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      var parts = value.split('.');
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
      return sample.replace(number, grouped + (decimals ? decimals + parts[1] : ''));
    };
  }

  function parseSection(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  /* Swap the drawer contents and header bubble from a Section Rendering response */
  function applySections(sections) {
    if (!sections) return;
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    var freshInner = sections['cart-drawer'] && parseSection(sections['cart-drawer'], '.drawer__inner');
    if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;

    var bubble = document.getElementById('cart-icon-bubble');
    var freshBubble = sections['cart-icon-bubble'] && parseSection(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;

    var el = drawer();
    if (el) {
      var empty = !!document.querySelector('#CartDrawer .drawer__inner-empty');
      el.classList.toggle('is-empty', empty);
    }
  }

  function refocus(target) {
    var container = document.getElementById('CartDrawer');
    if (!container || !isOpen() || typeof trapFocus !== 'function') return;
    trapFocus(container, target || container.querySelector('.drawer__close'));
  }

  function announce(cartData) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
  }

  /* ------------------------------ free shipping ------------------------------ */
  class DzFreeShipping extends HTMLElement {
    connectedCallback() {
      var rate = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : 1;
      if (!rate || rate === 1) return;

      // The threshold setting is in the shop's currency; rescale it for a converted cart.
      var threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
      var total = parseInt(this.dataset.total, 10);
      var format = moneyFormatter(this.dataset.moneySample);
      var remaining = threshold - total;
      var done = remaining <= 0;

      this.classList.toggle('is-done', done);
      var bar = this.querySelector('.dz-fs__bar i');
      if (bar) bar.style.width = Math.min(100, (total / threshold) * 100) + '%';
      var text = this.querySelector('.dz-fs__text');
      if (text) {
        text.textContent = done ? this.dataset.success : this.dataset.text.replace('[amount]', format(remaining));
      }
    }
  }

  /* ------------------------------ upsell row ------------------------------ */
  class DzCartUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dz-upsell__track');
      this.errorEl = this.querySelector('.dz-upsell__error');
      this.format = moneyFormatter(this.dataset.moneySample);
      this.exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
      this.limit = parseInt(this.dataset.limit, 10) || 8;
      this.addEventListener('click', this.onClick.bind(this));
      this.load();
    }

    fallback() {
      var node = this.querySelector('script[type="application/json"]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return [];
      }
    }

    recommendations() {
      var id = this.dataset.productId;
      if (!id || !this.dataset.url) return Promise.resolve([]);
      if (recommendationCache[id]) return Promise.resolve(recommendationCache[id]);
      return fetch(this.dataset.url + '.json?product_id=' + encodeURIComponent(id) + '&limit=10&intent=related')
        .then(function (response) {
          return response.ok ? response.json() : { products: [] };
        })
        .then(function (data) {
          recommendationCache[id] = data.products || [];
          return recommendationCache[id];
        })
        .catch(function () {
          return [];
        });
    }

    usable(products) {
      var exclude = this.exclude;
      return products.filter(function (product) {
        return product.available && exclude.indexOf(String(product.id)) === -1;
      });
    }

    load() {
      var self = this;
      this.recommendations().then(function (products) {
        var list = self.usable(products);
        if (!list.length) list = self.usable(self.fallback());
        self.render(list.slice(0, self.limit));
      });
    }

    render(products) {
      var self = this;
      this.hidden = products.length === 0;
      this.track.textContent = '';
      products.forEach(function (product) {
        self.track.appendChild(self.card(product));
      });
    }

    card(product) {
      var card = document.createElement('div');
      card.className = 'dz-upsell__card';

      var media = document.createElement('a');
      media.className = 'dz-upsell__media';
      media.href = product.url;
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
      if (product.featured_image) {
        var img = document.createElement('img');
        var src = product.featured_image;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 120;
        img.height = 120;
        media.appendChild(img);
      }
      card.appendChild(media);

      var body = document.createElement('div');
      body.className = 'dz-upsell__body';
      card.appendChild(body);

      var title = document.createElement('a');
      title.className = 'dz-upsell__title';
      title.href = product.url;
      title.textContent = product.title;
      body.appendChild(title);

      var onSale = product.compare_at_price > product.price;
      var prices = document.createElement('div');
      prices.className = 'dz-upsell__prices';
      var price = document.createElement('span');
      price.className = 'dz-upsell__price' + (onSale ? ' dz-upsell__price--sale' : '');
      price.textContent = this.format(product.price);
      prices.appendChild(price);
      if (onSale) {
        var was = document.createElement('s');
        was.className = 'dz-upsell__was';
        was.textContent = this.format(product.compare_at_price);
        prices.appendChild(was);
      }
      body.appendChild(prices);

      var variants = (product.variants || []).filter(function (variant) {
        return variant.available;
      });
      var single = (product.variants || []).length === 1 && variants.length === 1;
      var add = document.createElement(single ? 'button' : 'a');
      add.className = 'dz-upsell__add';
      add.textContent = this.dataset.addLabel || 'Add';
      if (single) {
        add.type = 'button';
        add.dataset.variantId = variants[0].id;
      } else {
        add.href = product.url;
      }
      add.setAttribute('aria-label', add.textContent + ': ' + product.title);
      card.appendChild(add);
      return card;
    }

    onClick(event) {
      var button = event.target.closest('button[data-variant-id]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      event.preventDefault();

      var self = this;
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var body = new FormData();
      body.append('id', button.dataset.variantId);
      body.append('quantity', '1');
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      config.body = body;

      button.setAttribute('aria-busy', 'true');
      this.errorEl.textContent = '';

      fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            button.removeAttribute('aria-busy');
            self.errorEl.textContent = response.description || response.message || '';
            return;
          }
          applySections(response.sections);
          announce(response);
          refocus(document.querySelector('#CartDrawer .cart-item__name'));
        })
        .catch(function () {
          button.removeAttribute('aria-busy');
          self.errorEl.textContent = window.cartStrings ? window.cartStrings.error : '';
        });
    }
  }

  /* ------------------------------ discount codes ------------------------------ */
  class DzCartDiscount extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.submit = this.querySelector('[type="submit"]');
      this.errorEl = this.querySelector('.dz-discount__error');
      this.codes = Array.prototype.map.call(this.querySelectorAll('[data-code]'), function (node) {
        return node.dataset.code;
      });

      if (discountOpen || discountError || this.codes.length) this.details.open = true;
      if (discountError) {
        this.errorEl.textContent = discountError;
        discountError = '';
      }

      var self = this;
      this.details.addEventListener('toggle', function () {
        discountOpen = self.details.open;
      });
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', this.onRemove.bind(this));
    }

    send(codes) {
      var body = JSON.stringify({
        discount: codes.join(','),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      });
      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body })).then(function (response) {
        return response.json();
      });
    }

    onSubmit(event) {
      event.preventDefault();
      var code = this.input.value.trim();
      if (!code) {
        this.errorEl.textContent = this.dataset.emptyError;
        this.input.focus();
        return;
      }

      var self = this;
      var kept = this.codes.slice();
      var duplicate = kept.some(function (existing) {
        return existing.toLowerCase() === code.toLowerCase();
      });
      if (duplicate) {
        this.input.value = '';
        return;
      }

      this.submit.setAttribute('aria-busy', 'true');
      this.errorEl.textContent = '';
      discountOpen = true;

      this.send(kept.concat(code))
        .then(function (cart) {
          var found = (cart.discount_codes || []).filter(function (entry) {
            return entry.code.toLowerCase() === code.toLowerCase() && entry.applicable;
          });
          if (found.length) return cart;
          // Not applicable: take it back off the cart and say so.
          discountError = self.dataset.invalidError.replace('[code]', code);
          return self.send(kept);
        })
        .then(function (cart) {
          applySections(cart.sections);
          announce(cart);
          refocus(document.querySelector('#CartDrawer .dz-discount input'));
        })
        .catch(function () {
          self.submit.removeAttribute('aria-busy');
          self.errorEl.textContent = window.cartStrings ? window.cartStrings.error : '';
        });
    }

    onRemove(event) {
      var button = event.target.closest('[data-remove-code]');
      if (!button) return;
      event.preventDefault();

      var self = this;
      var target = button.dataset.removeCode;
      button.setAttribute('aria-busy', 'true');
      discountOpen = true;

      this.send(
        this.codes.filter(function (code) {
          return code !== target;
        })
      )
        .then(function (cart) {
          applySections(cart.sections);
          announce(cart);
          refocus(document.querySelector('#CartDrawer .dz-discount input'));
        })
        .catch(function () {
          button.removeAttribute('aria-busy');
          self.errorEl.textContent = window.cartStrings ? window.cartStrings.error : '';
        });
    }
  }

  if (!customElements.get('dz-free-shipping')) customElements.define('dz-free-shipping', DzFreeShipping);
  if (!customElements.get('dz-cart-upsell')) customElements.define('dz-cart-upsell', DzCartUpsell);
  if (!customElements.get('dz-cart-discount')) customElements.define('dz-cart-discount', DzCartDiscount);

  /* ------------------------------ /cart page sync ------------------------------ */
  function refreshDrawer() {
    return fetch(routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(applySections);
  }

  function refreshCartPage() {
    return fetch(routes.cart_url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
          var current = document.getElementById(id);
          var fresh = html.getElementById(id);
          if (current && fresh) {
            current.innerHTML = fresh.innerHTML;
            current.className = fresh.className;
          }
        });
        var page = document.querySelector('cart-items');
        var freshPage = html.querySelector('cart-items');
        if (page && freshPage) page.classList.toggle('is-empty', freshPage.classList.contains('is-empty'));
      });
  }

  function bindSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!document.querySelector('cart-items')) return;
      // An edit in the open drawer refreshes the page; an edit on the page refreshes the drawer.
      if (isOpen() || event.source !== 'cart-items') {
        refreshCartPage();
      } else {
        refreshDrawer();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSync);
  else bindSync();
})();
